/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAssignmentDataSourcePathParams = NonNullable<
  operations['patchAssignmentDataSource']['parameters']['path']
>;

export type PatchAssignmentDataSourceRequestBody = OperationRequestBodyContent<operations['patchAssignmentDataSource']>;

export interface Input extends PatchAssignmentDataSourcePathParams {
  apiVersion?: string;
  body: PatchAssignmentDataSourceRequestBody;
}

export async function patchAssignmentDataSource(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projKey}/assignment-data-sources/{dataSourceKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
